import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=7aa9f488&scoped=true&"
import script from "./VerifyPage.vue?vue&type=script&lang=ts&"
export * from "./VerifyPage.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=7aa9f488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9f488",
  null
  
)

/* custom blocks */
import block0 from "./VerifyPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports